import { callAuthorizedGraphQLEndpoint } from '../../../../../Module/graphQL'

const getLogs = args => {
  const { campaignId } = args
  const query = `
  query getLogs($campaignId:ID!){
      campaign(id:$campaignId){
          logs{
              createdAt
              type,
              additionalInfo
              user {
                id
                firstName
                lastName
                role
              }
          }
      }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}

export { getLogs }
